export default [
  { key: "all", text: "clientPanelConstants:all", value: "0" },
  { key: "photosReady", text: "clientPanelConstants:photosReady", value: "1" },
  { key: "inProcess", text: "clientPanelConstants:inProcess", value: "2" },
  { key: "inactive", text: "clientPanelConstants:inactive", value: "3" },
  { key: "awaitingPayment", text: "clientPanelConstants:awaitingPayment", value: "4" },
  { key: "published", text: "clientPanelConstants:live", value: "5" },
];
